import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// HelmetProvider is lazy-loaded only when SEOHead is used
// No need to wrap root — SEOHead wraps itself

createRoot(document.getElementById("root")!).render(<App />);

// Global unhandled error & rejection logging
window.onerror = (msg, src, line, col, err) => { console.error("[Global]", msg, { src, line, col, err }); };
window.onunhandledrejection = (e: PromiseRejectionEvent) => { console.error("[UnhandledRejection]", e.reason); };

// Real User Monitoring: Web Vitals'ı idle-time'da topla
import("./lib/perfReporter").then(({ initPerfReporter }) => initPerfReporter()).catch(() => {});

// Defer service worker registration well after page is interactive
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    setTimeout(() => {
      navigator.serviceWorker.register('/sw.js').catch(() => {});
    }, 8000);
  });
}
